// eslint-disable-next-line
import React, { useReducer } from 'react';
import { Button } from '@cb/apricot-react';
import './common.scss';
import { localStateReducer } from '../../../utils/common';

const buttonStyles = {
  primary: {
    variant: 'primary',
  },
  secondary: {
    variant: 'yellow',
  },
  black: {
    variant: 'black',
  },
};

interface ReloadButtonProps {
  buttonStyle?: string;
  disabled?: boolean;
  refetch: () => void;
  reloadButtonID: string;
  reloadTimeStampID?: string;
  text: string;
  additionalClassNames?: string;
}

function ReloadButton({
  buttonStyle = 'primary',
  disabled = false,
  refetch = () => {},
  reloadButtonID = '',
  reloadTimeStampID = '',
  text = 'Reload',
  additionalClassNames = '',
}: ReloadButtonProps) {
  // Local state.
  const [localState, setLocalState] = useReducer(localStateReducer, {
    startSpinning: false,
  });

  function refreshData() {
    setLocalState({
      startSpinning: true,
    });
    refetch();
  }

  function stopSpin() {
    setLocalState({
      startSpinning: false,
    });
  }

  return (
    <Button
      aria-describedby={reloadTimeStampID}
      className={`w-100 ${localState.startSpinning ? 'refresh-icon--spin' : ''} refresh-icon ${additionalClassNames}`}
      icon='refresh'
      iconDecorative
      iconLeft
      id={reloadButtonID}
      onAnimationEnd={stopSpin}
      onClick={refreshData}
      small
      disabled={disabled}
      variant={buttonStyles[buttonStyle].variant}
    >
      <span>{text}</span>
    </Button>
  );
}

export default ReloadButton;
